import api from "./api";

async function getUser(userId: string) {
  return await api.get("/api/userInfo", {
    params: {
      id: userId,
      page: "Settings",
    },
  });
}

async function postOTSM(otsmArg: {
  fixedMargin: string,
  fixedMarkup: string | null,
  otsm: boolean,
  otsmDefault?: boolean
}) {
  return await api.put("/api/applyOTSM", otsmArg);
}

async function postFixedMargin(fixedMargin: number) {
  return await api.put("/api/applyFixedMargin", { fixedMargin });
}

async function postDeliveryMarkup(deliveryMarkup: boolean) {
  return await api.put("/api/deliveryMarkup", { deliveryMarkup });
}

async function postCrateFreightMarkup(hasMarkup: boolean) {
  return await api.put("/api/crateFreightMarkup", { hasMarkup });
}

export {
  postDeliveryMarkup,
  getUser,
  postOTSM,
  postFixedMargin,
  postCrateFreightMarkup,
};
